/*eslint-disable max-lines-per-function*/
import { useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { TfiPencilAlt } from 'react-icons/tfi';
import React, { JSX } from 'react';

import { LandingView } from '../pok/containers/LandingView/LandingView';
import { DocumentationView } from '../app/containers/DocumentationView';
import { ClientsView } from '../pok/containers/ClientsView/ClientsView';
import { CompaniesView } from '../pok/containers/CompaniesView/CompaniesView';
import { DictionariesTreeView } from '../pok/containers/DictionariesView/DictionariesTreeView';
import { EmployeesView } from '../pok/containers/EmployeesView/EmployeesView';
import { RolesView } from '../pok/containers/RolesView/RolesView';
import { EmployeesRolesView } from '../pok/containers/EmployeesRolesView/EmployeesRolesView';
import { TeamsView } from '../pok/containers/TeamsView/TeamsView';
import { OneToolTeamsView } from '../pok/containers/OneToolTeamsView/OneToolTeamsView';
import { BudgetsView } from '../pok/containers/BudgetsView/BudgetsView';
import { BudgetView } from '../pok/containers/BudgetsView/BudgetView';
import { BrandsView } from '../pok/containers/BrandsView/BrandsView';
import { ProfilesView } from '../pok/containers/ProfilesView/ProfilesView';
import { AllPurchasersView } from '../pok/containers/AllPurchasersView/AllPurchasersView';
import { AllPositionsView } from '../pok/containers/AllPositionsView/AllPositionsView';
import { ProjectsView } from '../pok/containers/ProjectsView/ProjectsView';
import { ProfileCategoriesView } from '../pok/containers/ProfileCategoriesView/ProfileCategoriesView';
import { ClientView } from '../pok/containers/ClientsView/ClientView';
import { ApplicationsView } from '../pok/containers/ApplicationsView/ApplicationsView';
import { ApplicationsAdminView } from '../pok/containers/ApplicationsView/ApplicationsAdminView';
import { ProjectDetailsView } from '../pok/containers/ProjectsView/ProjectDetailsView';
import { ProjectsApplicationView } from '../pok/containers/ProjectsApplicationView/ProjectsApplicationView';
import { ProjectsReadyToInvoiceView } from '../pok/containers/ProjectsReadyToInvoiceView/ProjectsReadyToInvoiceView';
import { SalesInvoiceView } from '../pok/containers/SalesInvoiceView/SalesInvoiceView';
import { PurchaseInvoicesView } from '../pok/components/PurchaseInvoices/PurchaseInvoicesView';
import { SalesInvoiceEditorView } from '../pok/containers/SalesInvoiceView/SalesInvoiceEditorView';
import { ProjectPurchaseInvoicesView } from '../pok/components/PurchaseInvoices/ProjectPurchaseInvoicesView';
import { BankAccountsView } from '../pok/containers/BankAccountsView/BankAccountsView';
import { ProjectAssignedPurchaseInvoicesView } from '../pok/components/PurchaseInvoices/ProjectAssignedPurchaseInvoicesView';
import { UsersInRoleView } from '../pok/containers/RolesView/UsersInRoleView';
import {
  OrdersView,
  ProjectOrdersTabs,
} from '../pok/containers/OrdersView/OrdersView';
import { OrderDecisionView } from '../pok/containers/OrdersView/OrderDecisionView';
import {
  OrdersExecutionTabs,
  OrdersExecutionView,
} from '../pok/containers/OrdersExecutionView/OrdersExecutionView';
import { OrderExecutionDecisionView } from '../pok/containers/OrdersExecutionView/OrderExecutionDecisionView';
import { PurchaseInvoiceAssignedToProjectsView } from '../pok/components/PurchaseInvoices/PurchaseInvoiceAssignedToProjectsView';
import { PurchaseInvoiceNotAssignedView } from '../pok/components/PurchaseInvoices/PurchaseInvoiceNotAssignedView';
import { SalesInvoicesReadyToCorrection } from '../pok/containers/SalesInvoicesReadyToCorrection/SalesInvoicesReadyToCorrection';
import { InstructionsView } from '../app/containers/InstructionsView';
import { SalesInvoiceEditorTabs } from '../pok/containers/SalesInvoiceView/SalesInvoiceEditorTabs';
import { VerificationView } from '../pok/containers/VerificationView/VerificationView';
import { ExportFVZToXMLView } from '../pok/containers/ExportFVZToXML/ExportFVZToXMLView';
import { ReportsView } from '../pok/containers/ReportsView/ReportsView';
import { ReportEstimateItemsDataRawView } from '../pok/containers/ReportsView/ReportEstimateItemsDataRawView';
import { ApplicationUnblockView } from '../pok/containers/ApplicaitonUnblockView/ApplicationUnblockView';
import { PurchasesInvoicesImportView } from '../pok/containers/PurchasesInvoicesImportView/PurchasesInvoicesImportView';
import { ReportProjectByMonthDataRawView } from '../pok/containers/ReportsView/ReportProjectByMonthDataRawView';
import { ReportsFinanceView } from '../pok/containers/ReportsView/ReportsFinanceView';
import { PackageFVZView } from '../pok/containers/ExportFVZToXML/PackageFVZView';
import { ExportFVSToXMLView } from '../pok/containers/ExportFVSToXML/ExportFVSToXMLView';
import { PackageFVSView } from '../pok/containers/ExportFVSToXML/PackageFVSView';
import { ClientsWithSymphonyView } from '../pok/containers/ClientsView/ClientsWithSymphonyView';
import { ClientSymphonyView } from '../pok/containers/ClientsView/ClientSymphonyView';
import { ExportFVSToSymphonyView } from '../pok/containers/ExportFVSToSymphony/ExportFVSToSymphonyView';
import { ReportFVZByFilterRawDataView } from '../pok/containers/ReportsView/ReportFVZByFilterRawDataView';
import { ProjectsFinanceView } from '../pok/containers/ProjectsView/ProjectsFinanceView';
import { ImportFinanceView } from '../pok/containers/PurchasesInvoicesImportView/ImportFinanceView';
import { PurchaseInvoiceView } from '../pok/components/PurchaseInvoices/PurchaseInvoiceView';
import { PurchaseInvoiceTabsEnum } from '../pok/components/PurchaseInvoices/PurchaseInvoiceTabsEnum';
import { SpecialInvoicingView } from '../pok/containers/SpecialInvoicingView/SpecialInvoicingView';
import { SpecialInvoicingEditorView } from '../pok/containers/SpecialInvoicingView/SpecialInvoicingEditorView';
import { ExcelConfigsView } from '../pok/containers/ExcelConfigsView/ExcelConfigsView';
import { ExcelConfigView } from '../pok/containers/ExcelConfigsView/ExcelConfigView';
import { SpecialInvoicingDecisionView } from '../pok/containers/SpecialInvoicingView/SpecialInvoicingDecisionView';
import { SpecialInvoicingDecisionEditorView } from '../pok/containers/SpecialInvoicingView/SpecialInvoicingDecisionEditorView';
import { EmailConfigsView } from '../pok/containers/EmailConfigView/EmailConfigsView';
import { ProjectExcelImportView } from '../pok/containers/ProjectExcelImportView/ProjectExcelImportView';
import { DocumentControlView } from '../pok/containers/DocumentControlView/DocumentControlView';
import { ReportFVZControllingByFilterRawDataView } from '../pok/containers/ReportsView/ReportFVZControllingByFilterRawDataView';
import { PurchaseInvoicesTvView } from '../pok/components/PurchaseInvoices/PurchaseInvoicesTvView';
import { PurchaseInvoiceTvView } from '../pok/components/PurchaseInvoices/PurchaseInvoiceTvView';
import { BlockadeView } from '../pok/containers/BlockadeView/BlockadeView';
import { ReportFVSControllingByFilterRawDataView } from '../pok/containers/ReportsView/ReportFVSControllingByFilterRawDataView';
import { ReportFVSEstimateItemsRawDataView } from '../pok/containers/ReportsView/ReportFVSEstimateItemsRawDataView';
import { ProceduresView } from '../app/containers/ProceduresView';
import { JobConfigView } from '../pok/containers/JobConfigView/JobConfigView';
import { ParamsView } from '../pok/containers/ParamsView/ParamsView';
import { TooltipsView } from '../pok/containers/TooltipsView/TooltipsView';
import { CalendarView } from '../pok/containers/CalendarView/CalendarView';
import { ReportFVSWithoutPositionsByFilterRawDataView } from '../pok/containers/ReportsView/ReportFVSWithoutPositionsByFilterRawDataView';
import { ReportFVSWithPositionsByFilterRawDataView } from '../pok/containers/ReportsView/ReportFVSWithPositionsByFilterRawDataView';
import { EstimateItemPurchaseDeficienciesView } from '../pok/containers/EstimateItemPurchaseDefiencies/EstimateItemPurchaseDeficienciesView';
import { SalesInvoicingView } from '../pok/containers/SalesInvoicing/SalesInvoicingView';
import { ProfileCategoryView } from '../pok/components/ProfileCategories/ProfileCategoryView';
import { AuthorizedView } from '../pok/containers/AuthorizedView/AuthorizedView';
import { ContractTabsEnum } from '../pok/components/Contracts/ContractTabsEnum';
import { ReportFVZDeficienciesDataRawView } from '../pok/containers/ReportsView/ReportFVZDeficienciesDataRawView';
import { ContractsOnlyForSomeBudgetTeamView } from '../pok/containers/ContractsView/ContractsOnlyForSomeBudgetTeamView';
import { ContractsOnlyForSomeBudgetTeamApprovalView } from '../pok/containers/ContractsView/ContractsOnlyForSomeBudgetTeamApprovalView';
import { ContractsOnlyForSomeBudgetTeamTVView } from '../pok/containers/ContractsView/ContractsOnlyForSomeBudgetTeamTVView';
import { ContractTVView } from '../pok/containers/ContractsView/ContractTVView';
import { ContractNoTVView } from '../pok/containers/ContractsView/ContractNoTVView';
import { SendFVSByEmailView } from '../pok/containers/SendFVSByEmail/SendFVSByEmailView';
import { ReportSalesInvoicingDataRawView } from '../pok/containers/ReportsView/ReportSalesInvoicingDataRawView';
import { ClientEmailsView } from '../pok/containers/ClientsView/ClientEmailsView';
import { EODErrorsView } from '../pok/containers/EODView/EODErrorsView';
import { ReportProjectsReadyToInvoiceRawDataView } from '../pok/containers/ReportsView/ReportProjectsReadyToInvoiceRawDataView';
import { HintsView } from '../pok/containers/TimeLineHintsView/HintsView';
import { RecommendedPublisherView } from '../pok/containers/RecommendedPublisherView/RecommendedPublisherView';
import { BulkDownloadFinanceDocumentsView } from '../pok/containers/BulkDownloadDocumentsView/BulkDownloadFinanceDocumentsView';
import { BulkDownloadAdminDocumentsView } from '../pok/containers/BulkDownloadDocumentsView/BulkDownloadAdminDocumentsView';
import { SurveysView } from '../pok/containers/SurveysView/SurveysView';
import { SurveyEditorView } from '../pok/containers/SurveyEditorView/SurveyEditorView';
import { ReportContractsMonitoringView } from '../pok/containers/ReportsView/ReportContractsMonitoringView';
import { ReportClientsContactsView } from '../pok/containers/ReportsView/ReportClientsContactsView';
import { ReportSurveyResultsView } from '../pok/containers/ReportsView/ReportSurveyResultsView';
import { SurveyPreviewView } from '../pok/containers/SurveyPreviewView/SurveyPreviewView';
import { PublicSurveyView } from '../pok/containers/PublicSurveyView/PublicSurveyView';
import { PurchasesInvoicesImportGeneralView } from '../pok/containers/PurchasesInvoicesImportView/PurchasesInvoicesImportGeneralView';
import { ClientSurveysView } from '../pok/containers/ClientSurveysView/ClientSurveysView';
import { ClientSurveyResultsView } from '../pok/containers/ClientSurveyResultsView/ClientSurveyResultsView';
import { SurveyAnswerView } from '../pok/containers/SurveyAnswerView/SurveyAnswerView';
import { StepsView } from '../pok/containers/TimeLineHintsView/StepsView';
import { ClientGroupsView } from '../pok/containers/ClientGroupsView/ClientGroupsView';
import { ClientGroupView } from '../pok/containers/ClientGroupsView/ClientGroupView';
import { SurveyClientsListView } from '../pok/containers/SurveyClientsListView/SurveyClientsListView';
import { EmailsView } from '../pok/containers/EmailsView/EmailsView';

import { useTranslation } from './hooks/useTranslation';
import { PermissionsEnum } from './pokCore/authorization/permissions';

export interface MenuItem {
  hr?: boolean;
  heading: string;
  path: string;
  icon?: Icon.Icon;
  element: JSX.Element;
  requiresAnyOf: PermissionsEnum[];
  requiresTeamAnyOf?: string[];
  requiresCompanyAnyOf?: string[];
  withContext?: boolean;
  withoutAuthentication?: boolean;
  submenu?: MenuItem[];
}

export const routesInMenu = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t, tk } = useTranslation('menuLng');
  return [
    {
      heading: t(tk.prLang.projects),
      path: '/projekty',
      icon: Icon.Megaphone,
      element: React.createElement(ProjectsView),
      requiresAnyOf: [PermissionsEnum.Projects],
      withContext: true,
      submenu: [
        {
          heading: t(tk.prLang.projectList),
          path: '/projekty/projekty',
          element: React.createElement(ProjectsView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.menu.applications),
          path: '/projekty/wnioski',
          element: React.createElement(ApplicationsView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.menu.specialInvoicingApplication),
          path: '/projekty/niestandardowe-fakturowanie',
          element: React.createElement(SpecialInvoicingView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.prLang.importProjectsFromFile),
          path: '/projekty/import',
          element: React.createElement(ProjectExcelImportView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        ...(process.env.REACT_APP_CONTRACTS?.toLocaleLowerCase() === 'on'
          ? [
              {
                hr: true,
                path: '',
                requiresAnyOf: [PermissionsEnum.Projects],
              },
              {
                heading: t(tk.menu.contracts),
                path: '/projekty/zlecenia',
                element: React.createElement(
                  ContractsOnlyForSomeBudgetTeamView,
                ),
                requiresAnyOf: [
                  PermissionsEnum.Projects,
                  PermissionsEnum.Administration,
                ],
                withContext: true,
              },
              {
                heading: t(tk.menu.contractsTV),
                path: '/projekty/tv-zlecenia',
                element: React.createElement(
                  ContractsOnlyForSomeBudgetTeamTVView,
                ),
                requiresAnyOf: [
                  PermissionsEnum.Projects,
                  PermissionsEnum.Administration,
                ],
                withContext: true,
              },
              {
                heading: t(tk.menu.contractsToSign),
                path: '/projekty/podpisywanie-zlecen',
                element: React.createElement(
                  ContractsOnlyForSomeBudgetTeamApprovalView,
                ),
                requiresAnyOf: [
                  PermissionsEnum.Projects,
                  PermissionsEnum.Administration,
                ],
                withContext: true,
              },
            ]
          : []),
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Projects],
        },
        {
          heading: t(tk.menu.purchaseInvoicesToBeClarified),
          path: '/projekty/faktury-zakupu',
          element: React.createElement(ProjectPurchaseInvoicesView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.prLang.purchaseInvoicesAssignedToProject),
          path: '/projekty/przypisane-faktury-zakupu-do-projektu',
          element: React.createElement(ProjectAssignedPurchaseInvoicesView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.menu.purchaseInvoicesTv),
          path: '/projekty/faktury-tv',
          element: React.createElement(PurchaseInvoicesTvView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.menu.estimateItemPurchaseDeficiencies),
          path: '/projekty/braki-zakupowe',
          element: React.createElement(EstimateItemPurchaseDeficienciesView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Projects],
        },
        {
          heading: t(tk.menu.salesInvoicing),
          path: '/projekty/sprzedaz-zafakturowanie',
          icon: Icon.FileBarGraph,
          element: React.createElement(SalesInvoicingView),
          requiresAnyOf: [PermissionsEnum.Projects, PermissionsEnum.Finance],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Projects],
        },
        {
          heading: t(tk.menu.orders),
          path: '/projekty/zamowienia',
          element: React.createElement(OrdersView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
        {
          heading: t(tk.menu.ordersExecutions),
          path: '/projekty/realizacje-zamowien',
          element: React.createElement(OrdersExecutionView),
          requiresAnyOf: [PermissionsEnum.Projects],
          withContext: true,
        },
      ],
    },
    {
      heading: t(tk.menu.finance),
      path: '/finanse',
      icon: Icon.CreditCard,
      element: React.createElement(ProjectsReadyToInvoiceView),
      requiresAnyOf: [PermissionsEnum.Finance],
      withContext: true,
      submenu: [
        {
          heading: t(tk.prLang.readyForInvoicing),
          path: '/finanse/gotowe-do-fakturowania',
          element: React.createElement(ProjectsReadyToInvoiceView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.salesInvoices),
          path: '/finanse/faktury-sprzedazy',
          element: React.createElement(SalesInvoiceView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.salesInvoicesReadyToCorrection),
          path: '/finanse/faktury-do-skorygowania',
          element: React.createElement(SalesInvoicesReadyToCorrection),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.purchaseInvoices),
          path: '/finanse/faktury-zakupu',
          element: React.createElement(PurchaseInvoicesView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.verifications),
          path: '/finanse/weryfikacja',
          element: React.createElement(VerificationView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.imports),
          path: '/finanse/import',
          element: React.createElement(ImportFinanceView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.prLang.projectsApplications),
          path: '/finanse/projekty-wnioski',
          element: React.createElement(ProjectsApplicationView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.prLang.applicationUnblocks),
          path: '/finanse/wnioski-odblokowanie-mediaplanu',
          element: React.createElement(ApplicationUnblockView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.specialInvoicingDecision),
          path: '/finanse/wnioski-niestandardowe-fakturowanie',
          element: React.createElement(SpecialInvoicingDecisionView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.blockade),
          path: '/finanse/blokady',
          element: React.createElement(BlockadeView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.menu.sendFVSToClients),
          path: '/finanse/wysylka-FVS',
          element: React.createElement(SendFVSByEmailView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.exportFVSToXml),
          path: '/finanse/eksport-fvs-xml',
          element: React.createElement(ExportFVSToXMLView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.exportFVSToSymphony),
          path: '/finanse/eksport-fvs-handel',
          element: React.createElement(ExportFVSToSymphonyView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        {
          heading: t(tk.menu.clientsWithSymphony),
          path: '/finanse/kontrahenci',
          element: React.createElement(ClientsWithSymphonyView),
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.menu.exportFVZToXml),
          path: '/finanse/eksport-fvz-xml',
          element: React.createElement(ExportFVZToXMLView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
        ...(process.env.REACT_APP_EOD?.toLocaleLowerCase() === 'on'
          ? [
              {
                heading: t(tk.menu.errorsEOD),
                path: '/finanse/bledy-eod',
                element: React.createElement(EODErrorsView),
                requiresAnyOf: [PermissionsEnum.Finance],
                withContext: true,
              },
            ]
          : []),
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.menu.reportsFinance),
          path: '/finanse/zestawienia-finanse',
          icon: Icon.FileBarGraph,
          element: React.createElement(ReportsFinanceView),
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.menu.downloadsDocuments),
          path: '/finanse/pobierz-dokumenty',
          element: React.createElement(BulkDownloadFinanceDocumentsView),
          requiresAnyOf: [PermissionsEnum.Finance],
        },
        {
          heading: t(tk.prLang.projectList),
          path: '/finanse/projekty-lista',
          element: React.createElement(ProjectsFinanceView),
          requiresAnyOf: [PermissionsEnum.Finance],
          withContext: true,
        },
      ],
    },
    {
      heading: t(tk.menu.reportsFinanceAdministration),
      path: '/admin-finanse',
      icon: Icon.CreditCard,
      element: React.createElement(ReportsFinanceView),
      requiresAnyOf: [PermissionsEnum.FinanceAdministration],
      withContext: true,
      submenu: [
        {
          heading: t(tk.menu.reportsFinance),
          path: '/admin-finanse/zestawienia-finanse',
          icon: Icon.FileBarGraph,
          element: React.createElement(ReportsFinanceView),
          requiresAnyOf: [PermissionsEnum.FinanceAdministration],
        },
        {
          heading: t(tk.menu.bankAccounts),
          path: '/admin-finanse/konta-bankowe',
          element: React.createElement(BankAccountsView),
          requiresAnyOf: [PermissionsEnum.FinanceAdministration],
        },
      ],
    },
    ...(process.env.REACT_APP_SURVEYS?.toLocaleLowerCase() === 'on'
      ? [
          {
            heading: t(tk.menu.surveys),
            path: '/ankiety',
            icon: TfiPencilAlt,
            element: React.createElement(SurveysView),
            requiresAnyOf: [PermissionsEnum.Surveys],
            withContext: true,
            submenu: [
              {
                heading: t(tk.menu.surveysList),
                path: '/ankiety/lista-ankiet',
                element: React.createElement(SurveysView),
                requiresAnyOf: [PermissionsEnum.Surveys],
              },
              {
                heading: t(tk.menu.clientSurveysWaiting),
                path: '/ankiety/ankiety-klientow',
                element: React.createElement(ClientSurveysView),
                requiresAnyOf: [PermissionsEnum.Surveys],
              },
              {
                heading: t(tk.menu.clientSurveyResults),
                path: '/ankiety/wyniki-ankiet',
                element: React.createElement(ClientSurveyResultsView),
                requiresAnyOf: [PermissionsEnum.Surveys],
              },
              {
                hr: true,
                path: '',
                requiresAnyOf: [PermissionsEnum.Surveys],
              },
              {
                heading: t(tk.menu.clientGroups),
                path: '/ankiety/grupy-kontrahentow',
                element: React.createElement(ClientGroupsView),
                requiresAnyOf: [PermissionsEnum.Surveys],
              },
              ...(process.env.REACT_APP_SURVEYS_CLIENTS?.toLocaleLowerCase() ===
              'on'
                ? [
                    {
                      heading: t(tk.menu.surveyClientsList),
                      path: '/ankiety/lista-kontrahentow',
                      element: React.createElement(SurveyClientsListView),
                      requiresAnyOf: [PermissionsEnum.Surveys],
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      heading: t(tk.menu.clients),
      path: '/kontrahenci',
      icon: Icon.People,
      element: React.createElement(ClientsView),
      requiresAnyOf: [PermissionsEnum.Clients, PermissionsEnum.FinanceClients],
      withContext: true,
      submenu: [
        {
          heading: t(tk.menu.clientsList),
          path: '/kontrahenci/kontrahenci',
          element: React.createElement(ClientsView),
          requiresAnyOf: [
            PermissionsEnum.Clients,
            PermissionsEnum.FinanceClients,
          ],
        },
        {
          heading: t(tk.menu.purchasers),
          path: '/kontrahenci/zamawiajacy',
          element: React.createElement(AllPurchasersView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          heading: t(tk.menu.positions),
          path: '/kontrahenci/pozycje',
          element: React.createElement(AllPositionsView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          heading: t(tk.menu.recommendedPublishers),
          path: '/kontrahenci/rekomendowaniDostawcy',
          element: React.createElement(RecommendedPublisherView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          heading: t(tk.menu.budgets),
          path: '/kontrahenci/budzety',
          element: React.createElement(BudgetsView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          heading: t(tk.menu.brands),
          path: '/kontrahenci/brandy',
          element: React.createElement(BrandsView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Clients],
        },
        {
          heading: t(tk.menu.applications),
          path: '/kontrahenci/wnioski',
          element: React.createElement(ApplicationsAdminView),
          requiresAnyOf: [PermissionsEnum.Clients],
        },
      ],
    },
    {
      heading: t(tk.menu.administrations),
      path: '/administracja',
      icon: Icon.Gear,
      element: React.createElement(CompaniesView),
      requiresAnyOf: [
        PermissionsEnum.Administration,
        PermissionsEnum.Permissions,
      ],
      submenu: [
        {
          heading: t(tk.menu.companies),
          path: '/administracja/spolki',
          element: React.createElement(CompaniesView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.employees),
          path: '/administracja/pracownicy',
          element: React.createElement(EmployeesView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.authorized),
          path: '/administracja/upowaznieni',
          element: React.createElement(AuthorizedView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.teams),
          path: '/administracja/zespoly',
          element: React.createElement(TeamsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.oneToolTeams),
          path: '/administracja/one-tool-zespoly',
          element: React.createElement(OneToolTeamsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.profiles),
          path: '/administracja/profile',
          element: React.createElement(ProfilesView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.profileCategories),
          path: '/administracja/kategorie-profili',
          element: React.createElement(ProfileCategoriesView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.dictionaries),
          path: '/administracja/slowniki',
          element: React.createElement(DictionariesTreeView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.calendar),
          path: '/administracja/kalendarz',
          element: React.createElement(CalendarView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Permissions],
        },
        {
          heading: t(tk.menu.roles),
          path: '/administracja/role',
          element: React.createElement(RolesView),
          requiresAnyOf: [PermissionsEnum.Permissions],
        },
        {
          heading: t(tk.menu.employeesRoles),
          path: '/administracja/uprawnienia',
          element: React.createElement(EmployeesRolesView),
          requiresAnyOf: [PermissionsEnum.Permissions],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.emailsList),
          path: '/administracja/lista-maili',
          element: React.createElement(EmailsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.emailConfigs),
          path: '/administracja/konfiguracja-maili',
          element: React.createElement(EmailConfigsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.jobConfig),
          path: '/administracja/konfiguracja-zadan',
          element: React.createElement(JobConfigView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.params),
          path: '/administracja/parametry',
          element: React.createElement(ParamsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.tooltips),
          path: '/administracja/tooltipy',
          element: React.createElement(TooltipsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          hr: true,
          path: '',
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        ...(process.env.REACT_APP_TIMELINE?.toLocaleLowerCase() === 'on'
          ? [
              {
                heading: t(tk.menu.timeLineHints),
                path: '/administracja/os-czasu-wskazowki',
                element: React.createElement(HintsView),
                requiresAnyOf: [PermissionsEnum.Administration],
              },
              {
                heading: t(tk.menu.timeLineSteps),
                path: '/administracja/os-czasu-kroki',
                element: React.createElement(StepsView),
                requiresAnyOf: [PermissionsEnum.Administration],
              },
              {
                hr: true,
                path: '',
                requiresAnyOf: [PermissionsEnum.Administration],
              },
            ]
          : []),
        {
          heading: t(tk.menu.excelConfig),
          path: '/administracja/konfiguracjaExcel',
          element: React.createElement(ExcelConfigsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
      ],
    },
    {
      heading: t(tk.menu.reports),
      path: '/zestawienia',
      icon: Icon.FileBarGraph,
      element: React.createElement(ReportsView),
      requiresAnyOf: [PermissionsEnum.Administration],
      submenu: [
        {
          heading: t(tk.menu.reports),
          path: '/zestawienia/zestawienia',
          element: React.createElement(ReportsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
        {
          heading: t(tk.menu.downloadsDocuments),
          path: '/zestawienia/pobierz-dokumenty',
          element: React.createElement(BulkDownloadAdminDocumentsView),
          requiresAnyOf: [PermissionsEnum.Administration],
        },
      ],
    },
    {
      heading: t(tk.menu.help),
      path: '/pomoc',
      icon: Icon.InfoCircle,
      element: React.createElement(InstructionsView),
      requiresAnyOf: [],
      submenu: [
        {
          heading: t(tk.menu.instructions),
          path: '/pomoc/instrukcje',
          element: React.createElement(InstructionsView),
          requiresAnyOf: [],
        },
        {
          heading: t(tk.menu.procedures),
          path: '/pomoc/procedury',
          element: React.createElement(ProceduresView),
          requiresAnyOf: [],
        },
        {
          heading: t(tk.menu.documentation),
          path: '/pomoc/dokumentacja',
          element: React.createElement(DocumentationView),
          requiresAnyOf: [],
        },
      ],
    },
  ] as MenuItem[];
};

export const routesOutsideMenu: MenuItem[] = [
  {
    heading: 'POK',
    path: '/',
    element: React.createElement(LandingView),
    requiresAnyOf: [],
  },
  {
    heading: 'Szczegóły',
    path: '/projekty/projekty/szczegoly/:projectId',
    element: React.createElement(ProjectDetailsView),
    requiresAnyOf: [],
    submenu: [],
  },
  {
    heading: 'Zlecenie',
    path: '/projekty/zlecenia/:contractId',
    element: React.createElement(ContractNoTVView),
    requiresAnyOf: [],
  },
  {
    heading: 'Zlecenie',
    path: '/projekty/zlecenia/utworz',
    element: React.createElement(ContractNoTVView),
    requiresAnyOf: [],
  },
  {
    heading: 'Zlecenie TV',
    path: '/projekty/tv-zlecenia/:contractId',
    element: React.createElement(ContractTVView),
    requiresAnyOf: [],
  },
  {
    heading: 'Zlecenie TV',
    path: '/projekty/tv-zlecenia/utworz',
    element: React.createElement(ContractTVView),
    requiresAnyOf: [],
  },
  {
    heading: 'Zamawiający',
    path: '/kontrahenci/kontrahenci/zamawiajacy/:clientId',
    icon: Icon.People,
    element: React.createElement(ClientView),
    requiresAnyOf: [],
    submenu: [],
  },
  {
    heading: 'Zamawiający',
    path: '/finanse/wysylka-FVS/zamawiajacy/:clientId',
    icon: Icon.People,
    element: React.createElement(ClientEmailsView),
    requiresAnyOf: [],
    submenu: [],
  },
  {
    heading: 'Budżety',
    path: '/kontrahenci/budzety/podglad/:id',
    element: React.createElement(BudgetView),
    requiresAnyOf: [],
  },
  {
    heading: 'Grupa kontrahentów',
    path: '/ankiety/grupy-kontrahentow/:groupId',
    element: React.createElement(ClientGroupView),
    requiresAnyOf: [],
  },
  {
    heading: 'Faktury sprzedaży',
    path: '/finanse/faktury-sprzedazy/utworz',
    element: React.createElement(SalesInvoiceEditorView),
    requiresAnyOf: [],
  },
  {
    heading: 'Faktura zakupu',
    path: '/finanse/faktury-zakupu/:purchaseInvoiceId',
    element: React.createElement(PurchaseInvoiceView),
    requiresAnyOf: [],
  },
  {
    heading: 'Faktura zakupu do wyjaśnienia',
    path: '/projekty/faktury-zakupu/:purchaseInvoiceId',
    element: React.createElement(PurchaseInvoiceNotAssignedView),
    requiresAnyOf: [],
  },
  {
    heading: 'Faktura zakupu przypisana do projektu',
    path: '/projekty/przypisane-faktury-zakupu-do-projektu/:purchaseInvoiceId',
    element: React.createElement(PurchaseInvoiceAssignedToProjectsView),
    requiresAnyOf: [],
  },
  {
    heading: 'Faktura zakupu TV',
    path: '/projekty/faktury-tv/:purchaseInvoiceId',
    element: React.createElement(PurchaseInvoiceTvView),
    requiresAnyOf: [],
  },
  {
    heading: 'Użytkownicy w roli',
    path: '/administracja/role/uzytkownicy-w-roli/:roleId',
    element: React.createElement(UsersInRoleView),
    requiresAnyOf: [],
  },
  {
    heading: 'Realizacja zamówienia',
    path: '/projekty/zamowienia/:orderId',
    element: React.createElement(OrderDecisionView),
    requiresAnyOf: [],
  },
  {
    heading: 'Akceptacja realizacji zamówienia',
    path: '/projekty/realizacje-zamowien/:orderExecutionId',
    element: React.createElement(OrderExecutionDecisionView),
    requiresAnyOf: [],
  },
  {
    heading: 'Surówka',
    path: '/zestawienia/surowka',
    element: React.createElement(ReportEstimateItemsDataRawView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Monitoring adopcji i jakości procesowej modułu zleceń',
    path: '/zestawienia/monitoring-zlecen',
    element: React.createElement(ReportContractsMonitoringView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Zestawienie kontaktów kontrahentów',
    path: '/zestawienia/kontakty-kontrahentow',
    element: React.createElement(ReportClientsContactsView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Zestawienie wyników ankiet',
    path: '/ankiety/wyniki-ankiet/zestawienie-wynikow',
    element: React.createElement(ReportSurveyResultsView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Zestawienie wyników ankiet z uwagami',
    path: '/ankiety/wyniki-ankiet/zestawienie-wynikow-z-uwagami',
    element: React.createElement(ReportSurveyResultsView, {
      withRemarks: true,
    }),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Dokumenty',
    path: '/zestawienia/pobierz-dokumenty',
    element: React.createElement(BulkDownloadAdminDocumentsView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Dokumenty',
    path: '/finanse/pobierz-dokumenty',
    element: React.createElement(BulkDownloadFinanceDocumentsView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Raport do budżetu',
    path: '/finanse/zestawienia-finanse/raport-do-budzetu',
    element: React.createElement(ReportProjectByMonthDataRawView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Braki zakupowe',
    path: '/finanse/zestawienia-finanse/braki-zakupowe',
    element: React.createElement(ReportFVZDeficienciesDataRawView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Sprzedaż - zafakturowanie',
    path: '/finanse/zestawienia-finanse/sprzedaz-zafakturowanie',
    element: React.createElement(ReportSalesInvoicingDataRawView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVS',
    path: '/finanse/zestawienia-finanse/fvs-without-positions',
    element: React.createElement(ReportFVSWithoutPositionsByFilterRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVS z nazwami pozycji',
    path: '/finanse/zestawienia-finanse/fvs-with-positions',
    element: React.createElement(ReportFVSWithPositionsByFilterRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVZ',
    path: '/finanse/zestawienia-finanse/fvz',
    element: React.createElement(ReportFVZByFilterRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVZ',
    path: '/finanse/zestawienia-finanse/fvz-kontroling',
    element: React.createElement(ReportFVZControllingByFilterRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVS',
    path: '/finanse/zestawienia-finanse/fvS-kontroling',
    element: React.createElement(ReportFVSControllingByFilterRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Pozycje kampanii - powiązania z FVS',
    path: '/finanse/zestawienia-finanse/fvs-estimate-items',
    element: React.createElement(ReportFVSEstimateItemsRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'FVS',
    path: '/finanse/zestawienia-finanse/projects-ready-to-invoice',
    element: React.createElement(ReportProjectsReadyToInvoiceRawDataView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Import FVZ z google',
    path: '/finanse/import/google-fvz',
    element: React.createElement(PurchasesInvoicesImportView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Import FVZ z plików',
    path: '/finanse/import/general-fvz',
    element: React.createElement(PurchasesInvoicesImportGeneralView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Paczka FVZ',
    path: '/finanse/eksport-fvz-xml/paczka-FVZ/:id',
    element: React.createElement(PackageFVZView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Paczka FVS',
    path: '/finanse/eksport-fvs-xml/paczka-FVS/:id',
    element: React.createElement(PackageFVSView),
    requiresAnyOf: [PermissionsEnum.Finance],
  },
  {
    heading: 'Kontrahenci',
    path: '/finanse/kontrahenci/:clientId',
    icon: Icon.People,
    element: React.createElement(ClientSymphonyView),
    requiresAnyOf: [],
    submenu: [],
  },
  {
    heading: 'Szczegóły konfiguracji',
    path: '/administracja/konfiguracjaExcel/szczegoly/:id',
    element: React.createElement(ExcelConfigView),
    requiresAnyOf: [],
    submenu: [],
  },
  {
    heading: 'Wnioski o niestandardowe fakturowanie',
    path: '/projekty/niestandardowe-fakturowanie/:specialInvoicingId',
    element: React.createElement(SpecialInvoicingEditorView),
    requiresAnyOf: [],
  },
  {
    heading: 'Wnioski o niestandardowe fakturowanie',
    path: '/finanse/wnioski-niestandardowe-fakturowanie/:specialInvoicingId',
    element: React.createElement(SpecialInvoicingDecisionEditorView),
    requiresAnyOf: [],
  },
  {
    heading: 'Kontrola dokumentów',
    path: '/projekty/kontrola-dokumentow/:id',
    element: React.createElement(DocumentControlView),
    requiresAnyOf: [PermissionsEnum.Projects],
    withContext: true,
  },
  {
    heading: 'Kategoria profilu',
    path: '/administracja/kategorie-profili/kategoria-profilu/:profileCategoryId',
    element: React.createElement(ProfileCategoryView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Nowa kategoria profilu',
    path: '/administracja/kategorie-profili/nowa-kategoria-profilu',
    element: React.createElement(ProfileCategoryView),
    requiresAnyOf: [PermissionsEnum.Administration],
  },
  {
    heading: 'Kontrola dokumentów',
    path: '/projekty/kontrola-dokumentow',
    element: React.createElement(DocumentControlView),
    requiresAnyOf: [PermissionsEnum.Projects],
    withContext: true,
  },
  {
    heading: 'Lista ankiet',
    path: '/ankiety/lista-ankiet',
    icon: Icon.People,
    element: React.createElement(SurveysView),
    requiresAnyOf: [PermissionsEnum.Surveys],
    submenu: [],
  },
  {
    heading: 'Edytor ankiety',
    path: '/ankiety/edytor-ankiety/:surveyId',
    element: React.createElement(SurveyEditorView),
    requiresAnyOf: [PermissionsEnum.Surveys],
    submenu: [],
  },
  {
    heading: 'Nowa ankieta',
    path: '/ankiety/nowa-ankieta',
    element: React.createElement(SurveyEditorView),
    requiresAnyOf: [PermissionsEnum.Surveys],
    submenu: [],
  },
  {
    heading: 'Podgląd ankiety',
    path: '/ankiety/podglad-ankiety/:surveyId',
    element: React.createElement(SurveyPreviewView),
    requiresAnyOf: [PermissionsEnum.Surveys],
    submenu: [],
  },
  {
    heading: 'Podgląd odpowiedzi ankiety',
    path: '/ankiety/wyniki-ankiet/podglad-odpowiedzi/:clientSurveyId',
    element: React.createElement(SurveyAnswerView),
    requiresAnyOf: [PermissionsEnum.Surveys],
    submenu: [],
  },
  {
    heading: 'Ankieta publiczna',
    path: '/survey/:token',
    element: React.createElement(PublicSurveyView),
    requiresAnyOf: [],
    withoutAuthentication: true,
  },
  {
    heading: 'POK',
    path: '*',
    element: React.createElement(LandingView),
    requiresAnyOf: [],
  },
];

const matchPath = (path: string, pattern: string) => {
  return path.startsWith(pattern);
};

export const currentMenuItems = (activePage: string) => {
  const items: MenuItem[] = [routesOutsideMenu[0]];

  for (const position of routesInMenu()) {
    if (matchPath(activePage, position.path)) {
      items.push(position);

      for (const subposition of position.submenu || []) {
        if (matchPath(activePage, subposition.path)) {
          items.push(subposition);
        }
      }
      break;
    }
  }

  return items;
};

export const useNavigation = () => {
  const navigate = useNavigate();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actions = (url: string, options?: any) => navigate(url, options);

  // const auth = useAuth();
  // const notifications = useNotifications();

  //const goWith = (role: Permissions, url: string, newWindow?: boolean) => {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const goWith = (url: string, newWindow?: boolean, options?: any) => {
    //if (!auth.check(role)) {
    //  notifications.unauthorized();
    //  return;
    //}
    if (!newWindow) {
      void actions(url, options);
    } else {
      window.open(url, '_blank');
    }
  };

  // const doc = (documentId?: string) => {
  //   if (!documentId) {
  //     return '';
  //   }
  //   return `/${documentId}`;
  // };

  return {
    menuItem: (location: string) => actions(location),
    help: () => actions('/pomoc'),
    reload: () => navigate(0),
    projectDetails: (id: string, newWindow?: boolean, tab?: string) => {
      if (tab) {
        return goWith(
          `/projekty/projekty/szczegoly/${id}?activeTab=${tab}`,
          newWindow,
        );
      }
      return goWith(`/projekty/projekty/szczegoly/${id}`, newWindow);
    },
    clientEditor: (id: string, newWindow?: boolean) =>
      goWith(`/kontrahenci/kontrahenci/zamawiajacy/${id}`, newWindow),
    purchaserEditor: (id: string, newWindow?: boolean) =>
      goWith(`/kontrahenci/kontrahenci/zamawiajacy/${id}`, newWindow),
    purchaserEmailsEditor: (id: string, newWindow?: boolean) =>
      goWith(`/finanse/wysylka-FVS/zamawiajacy/${id}`, newWindow),

    surveyAnswerView: (id: string, newWindow?: boolean) =>
      goWith(`/ankiety/wyniki-ankiet/podglad-odpowiedzi/${id}`, newWindow),
    clientSymphonyEditor: (id: string, newWindow?: boolean) =>
      goWith(`/finanse/kontrahenci/${id}`, newWindow),
    budget: (id: string, newWindow?: boolean) =>
      goWith(
        //Role.OrganizationsView,
        `/kontrahenci/budzety/podglad/${id}`,
        newWindow,
      ),
    clientGroup: (id: string, newWindow?: boolean) =>
      goWith(`/ankiety/grupy-kontrahentow/${id}`, newWindow),
    excelConfig: (id: string, newWindow?: boolean) =>
      goWith(
        //Role.OrganizationsView,
        `/administracja/konfiguracjaExcel/szczegoly/${id}`,
        newWindow,
      ),
    salesInvoiceEditor: ({
      projectId,
      salesInvoiceId,
      tab,
      notSavedTab,
      newWindow,
    }: {
      projectId?: string;
      salesInvoiceId?: string;
      tab?: SalesInvoiceEditorTabs;
      notSavedTab?: SalesInvoiceEditorTabs;
      newWindow?: boolean;
    }) => {
      const params = new URLSearchParams();
      const state: { tabKey?: string; notSavedTab?: string } = {};

      if (projectId) {
        params.set('projectId', projectId);
      }
      if (salesInvoiceId) {
        params.set('salesInvoiceId', salesInvoiceId);
      }

      if (tab) {
        state.tabKey = tab;
      }

      if (notSavedTab) {
        state.notSavedTab = notSavedTab;
      }

      return goWith(
        `/finanse/faktury-sprzedazy/utworz?${params.toString()}`,
        newWindow,
        {
          state,
        },
      );
    },
    salesInvoiceEditorNewWindow: (
      salesInvoiceId: string,
      newWindow?: boolean,
    ) => {
      const params = new URLSearchParams();
      params.set('salesInvoiceId', salesInvoiceId);
      return goWith(
        `/finanse/faktury-sprzedazy/utworz?${params.toString()}`,
        newWindow,
      );
    },
    purchaseInvoiceEditor: (id: string, newWindow?: boolean) =>
      goWith(`/finanse/faktury-zakupu/${id}`, newWindow),
    specialInvoicingEditor: (
      id: string,
      projectId?: string,
      newWindow?: boolean,
    ) =>
      goWith(
        `/projekty/niestandardowe-fakturowanie/${id}${projectId ? `?projectId=${projectId}` : ''}`,
        newWindow,
      ),
    specialInvoicingDecisionEditor: (id: string, newWindow?: boolean) =>
      goWith(`/finanse/wnioski-niestandardowe-fakturowanie/${id}`, newWindow),
    changePurchaseInvoiceEditorPath: (
      id: string,
      tab?: PurchaseInvoiceTabsEnum,
    ) =>
      navigate(`/finanse/faktury-zakupu/${id}`, {
        replace: true,
        state: {
          tabKey: tab,
        },
      }),
    projectPurchaseInvoiceEditor: (id: string, newWindow?: boolean) =>
      goWith(`/projekty/faktury-zakupu/${id}`, newWindow),
    tvPurchaseInvoiceEditor: (id: string, newWindow?: boolean) =>
      goWith(`/projekty/faktury-tv/${id}`, newWindow),
    projectAssignedPurchaseInvoiceEditor: (id: string, newWindow?: boolean) =>
      goWith(
        `/projekty/przypisane-faktury-zakupu-do-projektu/${id}`,
        newWindow,
      ),
    usersInRole: (id: string) =>
      navigate(`/administracja/role/uzytkownicy-w-roli/${id}`),
    orderEditorByTeam: (id: string, newWindow?: boolean) =>
      goWith(`/projekty/zamowienia/${id}`, newWindow),
    readyToInvoice: () => navigate('/finanse/gotowe-do-fakturowania'),
    salesInvoices: () => navigate('/finanse/faktury-sprzedazy'),
    orders: (tab?: ProjectOrdersTabs) =>
      navigate('/projekty/zamowienia', {
        state: {
          tabKey: tab,
        },
      }),
    orderExecutionEditor: (id: string, newWindow?: boolean) =>
      goWith(`/projekty/realizacje-zamowien/${id}`, newWindow),
    ordersExecution: (tab?: OrdersExecutionTabs) =>
      navigate('/projekty/realizacje-zamowien', {
        state: {
          tabKey: tab,
        },
      }),
    importAttachments: (newWindow?: boolean) =>
      goWith('/import/zalaczniki', newWindow),
    purchasesInvoicesImport: (newWindow?: boolean) =>
      goWith('/finanse/import/google-fvz', newWindow),
    purchasesInvoicesImportGeneral: (newWindow?: boolean) =>
      goWith('/finanse/import/general-fvz', newWindow),

    packagesFVZ: (id: string) =>
      navigate(`/finanse/eksport-fvz-xml/paczka-FVZ/${id}`),
    packagesFVS: (id: string) =>
      navigate(`/finanse/eksport-fvs-xml/paczka-FVS/${id}`),

    bulkDownloadDocuments: (newWindow?: boolean) =>
      goWith('/zestawienia/pobierz-dokumenty', newWindow),
    reportEstimateItemsDataRaw: (newWindow?: boolean) =>
      goWith('/zestawienia/surowka', newWindow),
    reportContractsMonitoring: (newWindow?: boolean) =>
      goWith('/zestawienia/monitoring-zlecen', newWindow),
    reportClientsContacts: (newWindow?: boolean) =>
      goWith('/zestawienia/kontakty-kontrahentow', newWindow),
    reportSurveyResults: (newWindow?: boolean) =>
      goWith('/ankiety/wyniki-ankiet/zestawienie-wynikow', newWindow),
    reportSurveyResultsWithRemarks: (newWindow?: boolean) =>
      goWith('/ankiety/wyniki-ankiet/zestawienie-wynikow-z-uwagami', newWindow),
    reportProjectByMonthDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/raport-do-budzetu', newWindow),
    reportFVZDeficienciesDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/braki-zakupowe', newWindow),
    reportSalesInvoicingDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/sprzedaz-zafakturowanie', newWindow),
    reportFVSWithoutPositionsByFilterDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvs-without-positions', newWindow),
    reportFVSWithPositionsByFilterDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvs-with-positions', newWindow),
    reportFVZByFilterDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvz', newWindow),
    reportFVZBWithEstimateItemsByFilterDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvz-kontroling', newWindow),
    reportFVSControllingByFilterDataRaw: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvs-kontroling', newWindow),
    reportProjectsReadyToInvoicesDataRaw: (newWindow?: boolean) =>
      goWith(
        '/finanse/zestawienia-finanse/projects-ready-to-invoice',
        newWindow,
      ),
    reportFVSEstimateItemsRawDataView: (newWindow?: boolean) =>
      goWith('/finanse/zestawienia-finanse/fvs-estimate-items', newWindow),

    documentsControl: () => goWith('/projekty/kontrola-dokumentow', true),
    documentsControlForProject: (id: string) =>
      goWith(`/projekty/kontrola-dokumentow/${id}`, true),
    salesInvoiceReadyToCorrection: (getUrl?: boolean) => {
      const url = '/finanse/faktury-do-skorygowania';
      if (getUrl) {
        return url;
      }

      return navigate(url);
    },
    profileCategoryEditor: (id: string, newWindow?: boolean) =>
      goWith(
        `/administracja/kategorie-profili/kategoria-profilu/${id}`,
        newWindow,
      ),
    profileCategoryAdd: (newWindow?: boolean) =>
      goWith(
        `/administracja/kategorie-profili/nowa-kategoria-profilu`,
        newWindow,
      ),
    profileCategories: (newWindow?: boolean) =>
      goWith('/administracja/kategorie-profili', newWindow),

    contractEditor: (id?: string, newWindow?: boolean) => {
      if (id) {
        return goWith(`/projekty/zlecenia/${id}`, newWindow);
      } else {
        return goWith(`/projekty/zlecenia/utworz`, newWindow);
      }
    },
    contractEditorTV: (id?: string, newWindow?: boolean) => {
      if (id) {
        return goWith(`/projekty/tv-zlecenia/${id}`, newWindow);
      } else {
        return goWith(`/projekty/tv-zlecenia/utworz`, newWindow);
      }
    },
    changeContractEditorPath: (
      id: string,
      tab?: ContractTabsEnum,
      tv?: boolean,
    ) =>
      navigate(
        tv ? `/projekty/tv-zlecenia/${id}` : `/projekty/zlecenia/${id}`,
        {
          replace: true,
          state: {
            tabKey: tab,
          },
        },
      ),
    previewSurvey: (id: string, newWindow?: boolean) =>
      goWith(`/ankiety/podglad-ankiety/${id}`, newWindow),
    changeSurveyEditorPath: (id: string) =>
      navigate(`/ankiety/edytor-ankiety/${id}`, {
        replace: true,
      }),
    surveyEditor: (id?: string, newWindow?: boolean) => {
      if (id) {
        return goWith(`/ankiety/edytor-ankiety/${id}`, newWindow);
      }
      return goWith('/ankiety/nowa-ankieta', newWindow);
    },
  };
};
